/**
 * Constrain a post-login redirect to a path on this origin.
 *
 * Mirrors `safeRedirectPath` in server/src/lib/http.ts, which is the
 * authoritative check — the server only ever hands back a path it has already
 * vetted. This copy is defence in depth for the one place the client navigates
 * to a destination it read out of a URL it did not build.
 */

const MAX_REDIRECT_LENGTH = 2048;

/** C0 controls and DEL. */
function hasControlCharacter(value: string): boolean {
  for (let i = 0; i < value.length; i++) {
    const code = value.charCodeAt(i);
    if (code < 32 || code === 127) return true;
  }
  return false;
}

export function safeRedirectPath(input: unknown): string {
  if (typeof input !== 'string') return '/';
  if (input.length === 0 || input.length > MAX_REDIRECT_LENGTH) return '/';
  if (!input.startsWith('/') || input.startsWith('//')) return '/';
  if (input.includes('\\') || hasControlCharacter(input)) return '/';
  return input;
}
